module.exports = __webpack_public_path__ + "img/exercise.2e449618.svg";